import { getDivination } from 'api/divine';
// import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

function useDivination() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getDivination, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('successfully divined', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

export { useDivination };
